import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import SectionHeaderDemo from './SectionHeaderDemo';

/**
 * Test page to display the SectionHeader component demo
 */
const SectionHeaderTestPage = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 0, mb: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Section Header Component
        </Typography>
        <Typography variant="body1" paragraph>
          This page demonstrates the SectionHeader component that replicates the design from Figma.
          The component is designed to be reusable and customizable for different sections of the application.
        </Typography>
      </Box>
      
      <SectionHeaderDemo />
    </Container>
  );
};

export default SectionHeaderTestPage;
